export const meta = {
  title: 'மார்க்கெட்டிங் அறிவிப்புகள்: சம்மதித்த அனைவரையும் சென்றடையுங்கள்',
  updatedAt: '2026-07-17',
  related: ['promotions', 'notifications'],
};

பிராட்காஸ்ட் என்பது ஒருமுறை எழுதி முழு பார்வையாளர் குழுவுக்கும் அனுப்பும் புஷ் அறிவிப்பு — புதிய சலுகை, புதிய தொகுப்பு, பண்டிகை நேரங்கள். உங்கள் QR-இலிருந்து வாடிக்கையாளர்கள் நிறுவிய அதே ஆப் வழியே அது அவர்களின் போனில் சேரும்.

## எழுதுதல்

**மார்க்கெட்டிங்** பக்கத்தில் இடதுபுறம் கடந்த பிரச்சாரங்கள், வலதுபுறம் எழுதும் கருவி. ஒரு பிரச்சாரம் என்பது தலைப்பு, செய்தி, உங்கள் ஆப்பின் ஒரு திரைக்கு விருப்ப இணைப்பு, மற்றும் பார்வையாளர் குழு. வெற்றுப் பெட்டியை வெறித்துப் பார்க்க விரும்பவில்லையா — **AI வரைவு** உதவி, ஒரு வாக்கிய நோக்கத்தைத் திருத்தக்கூடிய தலைப்பும் செய்தியுமாக மாற்றும்; சேமிக்கும் முன் திருத்தலாம்.

## பார்வையாளர் குழுக்கள்

நான்கு ஆயத்தக் குழுக்கள்:

- **அனைத்து வாடிக்கையாளர்கள்** — உங்கள் கடைகளில் எப்போதாவது பணம் செலுத்தியவர்கள் அனைவரும்.
- **கடந்த 30 நாள் செயலில்** — உங்கள் மிக அருகிலான பிரிவு.
- **வெள்ளி நிலை+** — வெகுமதிக்குத் தகுதியான விசுவாச வாடிக்கையாளர்கள்.
- **தங்க நிலை மட்டும்** — VIP-க்கு மட்டுமான சலுகைகள்.

"அனைத்தும்" பற்றிய ஒரு நேர்மையான குறிப்பு: நீங்கள் சென்றடையக்கூடிய பட்டியல், உங்களிடம் குறைந்தது ஒரு கட்டண கழுவலையாவது முடித்த வாடிக்கையாளர்கள்தான் — அந்தக் கணத்தில்தான் ஒருவர் உங்கள் வாடிக்கையாளர் பட்டியலில் சேர்கிறார். உங்கள் QR-ஐ ஸ்கேன் செய்தும் ஒருமுறையும் கழுவாதவருக்கு அனுப்ப முடியாது.

## "இப்போதே அனுப்பு" உண்மையில் என்ன செய்கிறது

அனுப்புதல் உடனே நடக்கும்; ஒவ்வொரு பெறுநரும் _அவர்களின்_ பாதுகாப்புக்காக வைக்கப்பட்ட மூன்று வாயில்களைக் கடக்க வேண்டும்:

- மார்க்கெட்டிங்கிலிருந்து விலகியவரா? **தவிர்க்கப்படும்.** அவர்களின் தேர்வு எப்போதும் மதிக்கப்படும்.
- அவர்களின் அமைதி நேரத்தில் (மாற்றவில்லை என்றால் 22:00–08:00)? **தவிர்க்கப்படும்.** மார்க்கெட்டிங் ஒருபோதும் அமைதி நேரத்தை ஊடுருவாது.
- போனில் அறிவிப்புகளை ஒருபோதும் அனுமதிக்கவில்லையா? **தவிர்க்கப்படும்** — சேர்ப்பிக்க வழியே இல்லை.

பிறகு ஒவ்வொரு பிரிவையும் பெயரிட்டுச் சொல்லும் சுருக்கம் கிடைக்கும்: அனுப்பியவை, சேர்ந்தவை, விருப்பத்தால் தவிர்க்கப்பட்டவை, அமைதி நேரத்தால் தவிர்க்கப்பட்டவை, அனுமதியின்மையால் தவிர்க்கப்பட்டவை, தோல்வியுற்றவை. எனவே "அனைத்து வாடிக்கையாளர்கள்" உங்கள் பட்டியலின் 60%-ஐ மட்டும் அடைந்தால், ஏன் என்பதைத் துல்லியமாகப் பார்க்கலாம் — மர்மம் இல்லை.

## சிக்கலிலிருந்து காக்கும் வரம்புகள்

- ஒரு வணிகத்துக்கு **நாளொன்றுக்கு 10 அறிவிப்புகள்**. உண்மையான மார்க்கெட்டிங்குக்குப் போதும்; ஸ்பேமுக்குப் போதாது.
- ஒரு அனுப்புதல் **10,000 பெறுநர்கள்** வரை கையாளும். பெரிய குழு வரம்பு வரை செயலாக்கப்பட்டு, சுருக்கம் அதை வெளிப்படையாகச் சொல்லும் — அமைதியான வெட்டு ஒருபோதும் இல்லை.
- அனுப்பப்பட்ட பிரச்சாரம் பூட்டப்படும்; இருமுறை அனுப்ப முடியாது. அதே செய்தியை மீண்டும் அனுப்ப, புதிய பிரச்சாரத்தை உருவாக்குங்கள்.

## நேர்மையான எல்லைகள்

அனுப்புதல்கள் **இப்போதே-மட்டும்** — எதிர்கால நேரத்திற்கான திட்டமிடல் இன்னும் இல்லை. புஷ் மட்டுமே **ஒரே சேனல்** — WhatsApp அல்லது SMS அறிவிப்புகள் இல்லை. மேலும் ஒரு அறிவிப்பு **ஒரே மொழியில்** செல்லும்: நீங்கள் தட்டச்சு செய்யும் தலைப்பும் செய்தியும்தான் ஒவ்வொரு பெறுநரும் படிப்பது; இன்னும் தானியங்கு மொழிபெயர்ப்பு இல்லை.
